import gql from "graphql-tag";
import classNames from "classnames";
import { Cards as CardsProps } from "../../../../__generated__/graphql";
import { ContentfulComponentType } from "../types";
import styles from "./ContentfulCards.module.css";
import { TextAndMediaCard } from "./TextAndMediaCard";
import ArticleCard from "components-shared/ArticleCard";
import TextFieldsV2 from "../TextFieldsV2";
import Gutter from "ui-kit/Gutter";
import { ContentfulC2A } from "../ContentfulC2A";
import { FlexCol } from "ui-kit/Layout/Flex";

export const ContentfulCards: ContentfulComponentType<CardsProps> = ({
  title,
  text,
  cardsCollection,
  c2A,
}) => {
  const cards = cardsCollection?.items ?? [];
  const isMultiple = cards.length > 2;

  return (
    <div className={classNames(styles.container, "container")}>
      <TextFieldsV2 title={title} text={text} center />
      <div
        className={
          isMultiple
            ? styles.cardsContainerMultiple
            : styles.cardsContainerSingle
        }
      >
        {cards.map((props) => {
          if (props?.__typename === "ComponentTextAndMedia") {
            return (
              <TextAndMediaCard
                {...props}
                key={`${props.__typename}-${props.title}`}
              />
            );
          }

          if (props?.__typename === "Article") {
            return (
              <ArticleCard
                article={props}
                key={`${props.__typename}-${props.title}`}
              />
            );
          }

          return null;
        })}
      </div>
      {c2A && (
        <FlexCol alignItems="center" justifyContent="center">
          <Gutter size={3} />
          <ContentfulC2A {...c2A} />
        </FlexCol>
      )}
    </div>
  );
};

ContentfulCards.fragment = gql`
  fragment Cards on ComponentCards {
    highlight
    title
    text
    cardsCollection(limit: 6) {
      items {
        ...TextAndMedia
        ...ArticleCardArticle
      }
    }
    c2A {
      ...C2A
    }
    sys {
      id
      publishedAt
    }
  }
  ${ArticleCard.fragments.article}
`;
